import { action, makeObservable, observable } from 'mobx';

import Auth from './AuthManager';

export const APP_MANAGER_ENDPOINTS = {
  FETCH_DYNAMIC_SATELLITE_BY_DOMAIN: '/api/viewPublisherSatelliteByDomain',
  FETCH_ONLINE_STATUS: '/api/zombie'
};

export class AppManager {
  constructor() {
    makeObservable(this);
  }

  classWorkspaceFeature = false; // TODO make observable
  trialFeature = false; // TODO make observable

  @observable initializingApp = false;
  @observable shouldReloadLoginPageAfterLogout = false;

  @observable location = null;

  @observable isDynamicSatellite = false;

  @action setInitializingApp = (toggle) => {
    this.initializingApp = toggle;
  }

  fetchDynamicSatelliteByDomain = async (locationOrigin = '') => {
    try {
      locationOrigin = locationOrigin || window?.location?.origin || '';
      // TODO useful for local development if you use QA domain urls
      // TODO for `publisher_satellite.satellite_url` values in your local database
      // TODO ---
      // TODO remember to comment back out before committing any changes
      // locationOrigin = 'https://qa-demo.content2classroom.com';
      // locationOrigin = 'https://qa-stemsports.content2classroom.com';
      // locationOrigin = 'https://qa-labaids.content2classroom.com';

      let apiUrl = `${Auth.ecms}${APP_MANAGER_ENDPOINTS.FETCH_DYNAMIC_SATELLITE_BY_DOMAIN}`;
      apiUrl += `?locationOrigin=${locationOrigin}`;

      const response = await Auth.fetch(apiUrl, { method: 'GET' });

      // TODO remove
      // console.info('response', response);

      if (!response?.data?.[0]) {
        throw new TypeError('NO_DYNAMIC_SATELLITE_RESPONSE_DATA');
      } else if (response?.status !== 'SUCCESS') {
        throw new TypeError(response?.statusMessage || response?.status);
      } else {
        return response?.data?.[0];
      }
    } catch (error) {
      console.error(error);
    }
  }

  fetchOnlineStatus = async () => {
    try {
      const { FETCH_ONLINE_STATUS } = APP_MANAGER_ENDPOINTS;
      const response = await Auth.fetch(`${Auth.ecms}${FETCH_ONLINE_STATUS}`, {
        method: 'GET'
      });
      return response;
    } catch (error) {
      console.error(error);
      return error;
    }
  }

  @action setShouldReloadLoginPageAfterLogout = () => {
    this.shouldReloadLoginPageAfterLogout = true;
  }

  /** @param {{ pathname: string; search: string; hash: string; state: undefined; key: string }} location} */
  @action setLocation = (location) => {
    this.location = location;
  }

  @action setIsDynamicSatellite = (isDynamicSatellite) => {
    this.isDynamicSatellite = isDynamicSatellite;
  }

  /** @deprecated */
  init(options) {
    Object.entries(options || {}).forEach(([key, value]) => this[key] = value);
  }
}

export default new AppManager();
